import {
  MARKET_PREVIEW,
  MARKET_NEW,
  MARKET_UPDATE,
  MARKET_REMOVE,
  MARKET_PROCESS_SUCCESS,
  MARKET_DATASOURCE_SUCCESS,
  MARKET_SEARCH,
  MARKET_PROCESS_RESET
  
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize:{},
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case MARKET_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case MARKET_NEW: {
      return {
          ...state,
          loader: true,
          process:{status:false,action:"",message:""}
      }
    }
    case MARKET_UPDATE:{
        return{
          ...state,
          loader:true,
          process:{status:false,action:"",message:""},
          dataSerialize:action.payload
        }
    }
    case MARKET_REMOVE: {
      return {
          ...state,
          loader: false
      }
    }
    case MARKET_SEARCH:{
        return {
            ...state,
            loader:false,
            keyword:action.payload
        }
    }
    case MARKET_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process:action.payload
      }
    }
    case MARKET_DATASOURCE_SUCCESS:{
        return {
            ...state,
            loader: false,
            dataSource: action.payload
        }
    }
    case MARKET_PROCESS_RESET:{
      return{
        ...state,
        process:{}
      }
    }
    default:
      return state
  }
}